import { gql } from '@apollo/client';
import eventAssignmentsFragment from './eventAssignmentsFragment';

const GET_EVENT_WITH_ASSIGNMENTS = gql`
  query GetEventWithAssignments($id: Int!) {
    eventWithAssignments(id: $id) {
      Id
      EventAssignments {
        ...EventAssignmentsFields
      }
    }
  }

  ${eventAssignmentsFragment}
`;

export default GET_EVENT_WITH_ASSIGNMENTS;
